import { LogglyTracker } from 'loggly-jslogger'

const Logger = new LogglyTracker()

function postLogs({ message, type, mac, appVersion }) {
  let log

  if (typeof message === 'object') {
    log = JSON && JSON.stringify ? JSON.stringify(message) : message
  } else if (Array.isArray(message)) {
    log = message.join()
  } else {
    log = message
  }

  const msg = {
    type,
    message: log,
    mac,
    appVersion
  }

  Logger.push(msg)
}

export const initConsole = ({ mac, appVersion }) => {
  const logTypes = ['log', 'error', 'info', 'warning']
  const nativeConsole = {}

  Logger.push({
    logglyKey: 'cd3644c9-66d2-4ad3-850b-88c0883c52cb',
    sendConsoleErrors: true,
    tag: 'javascript-logs'
  })

  for (let i = 0; i < logTypes.length; i++) {
    const type = logTypes[i]

    nativeConsole[type] = console[type]

    console[type] = function(message) {
      postLogs({ message, type, mac, appVersion })
      nativeConsole[type].apply(console, [message])
    }
  }
}
